import { AccService, WhoAmI } from 'api/schema/index'
import { OpenAPI } from 'api/schema/core/OpenAPI'
import { request as __request } from 'api/schema/core/request'

export type FavoriteKind = 'robot' | 'facility' | 'station' | 'organization'

export type FavoriteIds = {
  favorite_robot_ids: number[]
  favorite_facility_ids: number[]
  favorite_station_ids: number[]
  favorite_organization_ids: number[]
}

export const AccountApi = {
  login: async (email: string, password: string): Promise<WhoAmI> => {
    const user = await AccService.accLoginCreate({ email, password })
    return user
  },
  fetchUser: async (): Promise<WhoAmI> => {
    const user = await AccService.accWhoamiRetrieve()
    return user
  },
  logout: async () => {
    await AccService.accLogoutCreate()
  },
  restorePassword: async (email: string): Promise<void> => {
    await AccService.accPasswordResetCreate({ email })
  },
  setNewPassword: async (token: string, password: string): Promise<void> => {
    await AccService.accPasswordResetConfirmCreate({ token, password })
  },
  changePassword: async (
    currentPassword: string,
    newPassword: string,
    newPasswordAgain: string
  ): Promise<void> => {
    await AccService.accPasswordChangeCreate({
      current_password: currentPassword,
      new_password: newPassword,
      new_password_again: newPasswordAgain,
    })
  },
  uploadAvatar: async (file: File): Promise<WhoAmI> => {
    const body = new FormData()
    body.append('avatar', file)
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/acc/avatar/',
      body,
    })
  },
  deleteAvatar: async (): Promise<WhoAmI> => {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/acc/avatar/',
    })
  },
  toggleFavorite: async (kind: FavoriteKind, id: number): Promise<FavoriteIds> => {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/acc/favorites/toggle/',
      body: { kind, id },
    })
  },
}
